import { HasOnComplete, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { ApiParameter, del, get, post } from "@insite/client-framework/Services/ApiService";

export interface ExportDataParameter extends ApiParameter {
    customerID: string;
    onError?: (errorMessage: string) => void;
}

export interface DeleteScheduleDataParameter extends ApiParameter {
    customerID: string;
}

export interface ScheduleDataParameter extends ApiParameter {
    customerID: string;
    recipientEmail: string;
    frequency: string;
    interval: number | undefined | null;
    day: string | null;
    message: string;
    startDate: Date;
    endDate: undefined;
    noEndDate: boolean;
    onSuccess?: () => void;
}

export interface ExportDataApiModel { }

export interface ScheduleDataApiModel { }

export interface ExportDetailsDataApiModel { 
    customerID: string;
    recipientEmail: string;
    frequency: string;
    interval: number | undefined;
    day: string | null;
    message: string;
    startDate: Date;
    endDate: Date | null;
    noEndDate: boolean;
}

const downloadExportUrl = "api/v1/downloadexport";
const scheduleExportUrl = "api/v1/scheduleexport";

export async function loadExportData(
    parameter: ExportDataParameter & HasOnSuccess<ExportDataParameter> & HasOnComplete<ExportDataParameter>,
) {
    const apiParameter = { ...parameter };
    const response = await get<ExportDataApiModel>(downloadExportUrl, apiParameter);
    return response;
}

export async function loadScheduleData(
    parameter: ScheduleDataParameter & HasOnSuccess<ScheduleDataParameter> & HasOnComplete<ScheduleDataParameter>,
) {
    const apiParameter = { ...parameter };
    const response = await post<ScheduleDataApiModel>(scheduleExportUrl, apiParameter);
    return response;
}

export async function getExportDetailsData(
    parameter: ExportDataParameter & HasOnSuccess<ExportDataParameter> & HasOnComplete<ExportDataParameter>,
) {
    const apiParameter = { ...parameter };
    const response = await get<ExportDetailsDataApiModel>(scheduleExportUrl, apiParameter);
    return response;
}

export function deleteExportDetailsData(parameter: DeleteScheduleDataParameter) {
    return del(`${scheduleExportUrl}?customerID=${parameter.customerID}`);
}